import { render } from "./erwinVue.vue?vue&type=template&id=27f6f0b0&lang=true"
import script from "./erwinVue.vue?vue&type=script&lang=js"
export * from "./erwinVue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__